module.exports = __webpack_public_path__ + "static/media/develop-logo-02.d22a9db1.png";